<template>
  <v-app id="materialpro" :class="`${!$vuetify.breakpoint.smAndDown ? 'full-sidebar' : 'mini-sidebar'}`">
    <router-view />
  </v-app>
</template>

<script>
//import AppService from './AppService';
/*import Swal from 'sweetalert2';*/

export default {
  name: 'App',
  components: {},
  async mounted() {
    //const x = this.$httpService(new AppService(), this);
    //console.log(swal);
    //const res = await x.get().execResource('comments', { id: 1, des: 2 });
    //console.log(await x.post().exportResource('comments'), {});
    // console.log(await x.get().execResource('comments', { a: 1, b: 2, c: 3, d: 4, e: '12' }));
    //console.log(await x.get().execResource('comments', { postId: 1 }));
    //console.log('----------------------------------------');
    //console.log(process.env.VUE_APP_API_URL);
    //console.log(process.env.VUE_APP_API_URL2);
    //console.log(process.env.VUE_APP_API_URL3);
    //console.log('----------------------------------------');
    //console.log(await x.post().execResource('comments'));
    //console.log(await x.delete().execResource('comments'));
    //console.log(await x.execResource('comments'));
    //console.log('get', x.get());
    //console.log(x.exec());
    //console.log('MOUNTED');
    //console.log(this);
    //HttpHandlerService.get();
    /*await Swal.fire({
      title: 'Error!',
      text: 'Do you want to continue',
      icon: 'error',
      confirmButtonText: 'Cool'
    });*/
  }
};
</script>
